// AddUserModal.jsx
import React, { useState } from "react";
import { Dropdown, DropdownMenu, FormControl } from "react-bootstrap";
import { X } from "lucide-react";

const AddUserModal = ({ isOpen, onClose }) => {
  const allSpecialities = [
    "Cardiology",
    "Orthopedics",
    "Neurology",
    "Dermatology",
  ];
  const allRegions = ["Texas", "California", "New York", "Florida"];
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [touched, setTouched] = useState(false);
  const [state, setState] = useState({
    clinical: {
      selected: [],
      searchQuery: "",
      showDropdown: false,
      options: allSpecialities,
    },
    region: {
      selected: [],
      searchQuery: "",
      showDropdown: false,
      options: allRegions,
    },
  });
  const [selected, setSelected] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  if (!isOpen) return null;

  const toggleOption = (option) => {
    if (selected.includes(option)) {
      setSelected(selected.filter((item) => item !== option));
    } else {
      setSelected([...selected, option]);
    }
  };

  const handleSelect = (id, value) => {
    if (!state[id].selected.includes(value)) {
      setState((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          selected: [...prev[id].selected, value],
        },
      }));
    }
  };

  const removeTag = (id, value) => {
    setState((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        selected: prev[id].selected.filter((item) => item !== value),
      },
    }));
  };

  const handleSearch = (id, value) => {
    setState((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        searchQuery: value,
      },
    }));
  };

  const toggleDropdown = (id, isOpen) => {
    setState((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        showDropdown: isOpen,
      },
    }));
  };

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(value)) {
      return "Invalid email format.";
    }
    return "";
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (touched) {
      setError(validateEmail(value));
    }
  };

  const handleBlur = () => {
    setTouched(true);
    setError(validateEmail(email));
  };

  const renderDropdown = (id, label) => {
    const { selected, searchQuery, showDropdown, options } = state[id];
    const filteredOptions = options
      .filter((opt) => !selected.includes(opt))
      .filter((opt) => opt.toLowerCase().includes(searchQuery.toLowerCase()));

    return (
      <div className="multi-select-container">
        <p>{label}</p>
        <div className="tags">
          {selected.map((item) => (
            <span key={item} className="tag">
              {item}
              <button onClick={() => removeTag(id, item)}>×</button>
            </span>
          ))}
        </div>
        <Dropdown
          show={showDropdown}
          onToggle={(isOpen) => toggleDropdown(id, isOpen)}
        >
          <Dropdown.Toggle variant="tertiary" className="w-100">
            {selected.length > 0 ? selected.join(", ") : `Select ${label}`}
          </Dropdown.Toggle>
          <Dropdown.Menu className="w-100">
            <div className="px-2 py-1">
              <FormControl
                autoFocus
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => handleSearch(id, e.target.value)}
              />
            </div>
            <div style={{ maxHeight: "200px", overflowY: "auto" }}>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <Dropdown.Item
                    key={option}
                    onClick={() => handleSelect(id, option)}
                  >
                    {option}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item disabled>No results</Dropdown.Item>
              )}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add User</h5>
        </div>
        <form>
          <div>
            <p>Basic Information</p>
            <div className="user-form-wrapper">
              <div className="flex-item">
                <label className="mb-1">Full Name</label>
                <input type="text" placeholder="Enter your full name" />
              </div>
              <div className="flex-item">
                <div className="d-flex gap-2 align-items-center">
                  <label className="mb-1">Email</label>{" "}
                  {error && touched && email && (
                    <span
                      style={{
                        color: "red",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      {error}
                    </span>
                  )}
                </div>
                <input
                  type="text"
                  value={email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your valid email"
                  style={{
                    borderColor: error && touched && email ? "red" : "",
                    outline: "none",
                  }}
                />
              </div>
              <div className="flex-item">
                <label className="mb-1">Role</label>
                <Dropdown className="config-filter-dropdown">
                  <Dropdown.Toggle>{"All Priorities"}</Dropdown.Toggle>
                  <Dropdown.Menu>
                    {["Urgent", "High", "Low", "Overdue", "Nil assigned"].map(
                      (priority) => (
                        <Dropdown.Item>{priority}</Dropdown.Item>
                      )
                    )}
                  </Dropdown.Menu>
                </Dropdown>
                <Dropdown>
                  <Dropdown.Menu>1</Dropdown.Menu>
                  <Dropdown.Menu>1</Dropdown.Menu>
                  <Dropdown.Menu>1</Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="flex-item">
                <label className="mb-1">Expertise Level</label>
                <Dropdown className="config-filter-dropdown">
                  <Dropdown.Toggle>{"All Priorities"}</Dropdown.Toggle>
                  <Dropdown.Menu>
                    {["Trainee","Junior", "Senior"].map(
                      (priority) => (
                        <Dropdown.Item>{priority}</Dropdown.Item>
                      )
                    )}
                  </Dropdown.Menu>
                </Dropdown>
                <Dropdown>
                  <Dropdown.Menu>1</Dropdown.Menu>
                  <Dropdown.Menu>1</Dropdown.Menu>
                  <Dropdown.Menu>1</Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          <div className="mt-2">
            {renderDropdown("clinical", "Clinical Specialities")}
          </div>

          <div className="mt-3">
            {renderDropdown("region", "States /Regions")}
          </div>
          <div className="d-flex gap-2">
            <div className="flex-item mt-2">
              <p>Additional Settings</p>
              <div>
                <label>Public/ Private Role</label>
                <Dropdown className="config-filter-dropdown mt-2">
                  <Dropdown.Toggle>{"All Priorities"}</Dropdown.Toggle>
                  <Dropdown.Menu>
                    {["Public", "Private"].map(
                      (priority) => (
                        <Dropdown.Item>{priority}</Dropdown.Item>
                      )
                    )}
                  </Dropdown.Menu>
                </Dropdown>
                <Dropdown>
                  <Dropdown.Menu>1</Dropdown.Menu>
                  <Dropdown.Menu>1</Dropdown.Menu>
                  <Dropdown.Menu>1</Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div className="flex-item" style={{ marginTop: "35px" }}>
              <label>Availability</label>
              <Dropdown className="config-filter-dropdown mt-2">
                <Dropdown.Toggle>{"Select"}</Dropdown.Toggle>
                <Dropdown.Menu>
                  {["Active", "On Leave", "Training"].map((priority) => (
                    <Dropdown.Item>{priority}</Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown>
                <Dropdown.Menu>1</Dropdown.Menu>
                <Dropdown.Menu>1</Dropdown.Menu>
                <Dropdown.Menu>1</Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <div className="d-flex mt-4 gap-2 justify-content-center">
            <button type="submit" className="user-details-submit-btn">
              Submit
            </button>
            <button
              type="button"
              className="user-details-cancel-btn"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserModal;
